import cookie from '../cookie'

export default class Auth {
  constructor(api) {
    this.api = api
  }

  login = async (ConsumerId, Password, TDCampaigns) => {
    const res = await this.api.post('/authentication/login', {
      data: {
        ConsumerId,
        Password,
        TDCampaigns
      },
      headers: {
        ...cookie.tokenHeader()
      }
      // mock: 'login.json'
    })
    return res
  }

  loginV2 = async (ConsumerId, Password, TDCampaigns) => {
    const res = await this.api.post('/authentication/loginv2', {
      data: {
        ConsumerId,
        Password,
        TDCampaigns
      },
      withCredentials: true,
      useProxy: true,
      headers: {
        ...cookie.tokenHeader()
      },
      mock: 'loginV2.json'
    })
    return res
  }

  logout = async token => {
    const res = await this.api.post(
      '/authentication/loginv2session?logout=true',
      {
        data: {
          token: token || cookie.getToken()
        },
        useProxy: true,
        withCredentials: true,
        mock: 'loginV2Session.json'
      }
    )
    return res
  }

  makeLoginUsingSSOEndpoint = async token => {
    const res = await this.api.post('/authentication/loginv2session', {
      data: {
        token
      },
      useProxy: true,
      withCredentials: true,
      mock: 'loginV2Session.json'
    })
    return res
  }

  getCardBirthDate = async (data, isNHAV = false) => {
    const res = await this.api.post(
      '/account/ageverification?' + (isNHAV ? '&folder=Final' : ''),
      {
        data,
        headers: { 'content-type': 'image/png' },
        mock: 'getCardBirthDate.json'
      }
    )
    return res
  }

  verifyAge = async (ocrToken, token) => {
    const res = await this.api.put(
      `/account/registration/verifyage?ocr=${ocrToken}`,
      {
        ...(token && { headers: { Authorization: `Bearer ${token}` } }),
        mock: 'verifyAge.json'
      }
    )
    return res
  }

  getAddConsumerFormData = async () => {
    const res = await this.api.get('/account/registration/formdata', {
      mock: 'getAddConsumerFormData.json'
    })
    return res
  }

  getAddressInfo = async opts => {
    const res = await this.api.get('/catalogue/addressinfo', {
      headers: {
        ...cookie.authorizationTokenHeader(opts, false, true)
      },
      ...opts
    })
    cookie.setToken(res.auth_token)
    return res
  }

  getPrefilledConsumerFormData = async opts => {
    const res = await this.api.get('/account/registration/formdata/contact', {
      headers: {
        ...cookie.authorizationTokenHeader(opts)
      },
      ...opts,
      mock: 'getPrefilledConsumerFormData.json'
    })
    return res
  }

  accountRegistration = async (data, token) => {
    const res = await this.api.post('/account/registration', {
      ...(token && { headers: { Authorization: `Bearer ${token}` } }),
      data,
      withCredentials: true,
      useProxy: true,
      mock: 'accountRegistration.json'
    })
    cookie.setToken(res.auth_token)
    return res
  }

  requestEmailVerificationPINRegistration = async (
    emailAddress,
    action,
    token
  ) => {
    const res = await this.api.post('/account/registration/request/pin/email', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      data: {
        emailAddress,
        action,
        token
      },
      mock: 'requestEmailVerificationPINRegistration.json'
    })
    cookie.setToken(res.auth_token)
    return res
  }

  requestEmailVerificationPIN = async (email_address, newAddress) => {
    const res = await this.api.post(
      newAddress
        ? '/profile/request/pin/email'
        : '/profile/verify/request/email',
      {
        headers: {
          ...cookie.authorizationTokenHeader(null, false, true)
        },
        ...(newAddress && {
          data: {
            emailAddress: email_address
          }
        }),
        mock: 'requestEmailVerificationPIN.json'
      }
    )
    cookie.setToken(res.auth_token)
    return res
  }

  verifyEmailPin = async verification_code => {
    const res = await this.api.post('/VerifyEmailPin', {
      headers: {
        ...cookie.authorizationTokenHeader(null, false, true)
      },
      withCredentials: true,
      useProxy: true,
      data: {
        verification_code
      },
      mock: 'verifyEmailPin.json'
    })
    cookie.setToken(res.auth_token)
    return res
  }

  requestSMSVerificationPINRegistration = async data => {
    const res = await this.api.post('/account/registration/request/pin/sms', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      data,
      mock: 'requestSMSVerificationPINRegistration.json'
    })
    cookie.setToken(res.auth_token)
    return res
  }

  requestSMSVerificationPIN = async (phone_number, newPhone) => {
    const res = await this.api.post(
      newPhone ? '/profile/request/pin/sms' : '/profile/verify/request/phone',
      {
        headers: {
          ...cookie.authorizationTokenHeader(null, false, true)
        },
        ...(newPhone && {
          data: {
            phoneNumber: phone_number
          }
        }),
        mock: 'requestSMSVerificationPIN.json'
      }
    )
    cookie.setToken(res.auth_token)
    return res
  }

  requestVoiceVerificationPINRegistration = async data => {
    const res = await this.api.post('/account/registration/request/pin/tts', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      data,
      mock: 'requestVoiceVerificationPINRegistration.json'
    })
    cookie.setToken(res.auth_token)
    return res
  }

  requestVoiceVerificationPIN = async (phone_number, newPhone) => {
    const res = await this.api.post(
      newPhone
        ? '/profile/request/pin/tts'
        : '/profile/verify/request/phone/tts',
      {
        headers: {
          ...cookie.authorizationTokenHeader(null, false, true)
        },
        ...(newPhone && {
          data: {
            phoneNumber: phone_number
          }
        }),
        mock: 'requestVoiceVerificationPIN.json'
      }
    )
    cookie.setToken(res.auth_token)
    return res
  }

  verifyPhonePin = async verification_code => {
    const res = await this.api.post('/VerifyPhonePin', {
      headers: {
        ...cookie.authorizationTokenHeader(null, false, true)
      },
      withCredentials: true,
      useProxy: true,
      data: {
        verification_code
      },
      mock: 'verifyPhonePin.json'
    })
    cookie.setToken(res.auth_token)
    return res
  }

  docomoRegistration = async ({ code, state, source }) => {
    const res = await this.api.post('/account/registration/docomo', {
      data: {
        code,
        state,
        source
      }
    })
    cookie.setToken(res.auth_token)
    return res
  }

  accountPasswordReset = async (loginname, birthday, recaptcha = {}) => {
    const res = await this.api.post('/account/password/reset', {
      data: {
        loginname,
        birthday,
        token: recaptcha.token,
        action: recaptcha.action
      },
      mock: 'accountPasswordReset.json'
    })
    return res
  }

  accountLoginnameRecover = async (email, recaptcha = {}) => {
    const res = await this.api.post('/account/loginname/recover', {
      data: {
        email,
        token: recaptcha.token,
        action: recaptcha.action
      },
      mock: 'accountLoginnameRecover.json'
    })
    return res
  }

  accountPasswordChange = async (password, token) => {
    const res = await this.api.post('/account/password/change', {
      data: {
        token,
        password
      },
      mock: 'accountPasswordChange.json'
    })
    return res
  }

  verifyEmailPinRegistration = async (email, pin) => {
    const res = await this.api.post('/account/registration/validate/email', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      withCredentials: true,
      useProxy: true,
      data: {
        email,
        pin
      },
      mock: 'verifyEmailPinRegistration.json'
    })
    return res
  }

  verifyPhonePinRegistration = async (phone, pin) => {
    const res = await this.api.post('/account/registration/validate/phone', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      withCredentials: true,
      useProxy: true,
      data: {
        phone,
        pin
      },
      mock: 'verifyPhonePinRegistration.json'
    })
    return res
  }

  getPosition = async (sync = false, fetchNotices = false, logout = false) => {
    const res = await this.api.get(
      '/iqosphere/position' +
        (sync ? '?sync=true' : '') +
        (logout ? '?logout=true' : ''),
      {
        headers: {
          ...cookie.authorizationTokenHeader()
        },
        data: {
          notices: fetchNotices
        },
        useProxy: true,
        withCredentials: true,
        mock: 'position.json'
      }
    )
    return res
  }
}
